export const responseMessageDispaly = (ref, msg, className) => {
  ref.current.innerHTML = msg;
  ref.current.classList.add(className);
  setTimeout(function () {
    ref.current.innerHTML = "";
    ref.current.classList.remove(className);
  }, 3000);
};
